import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import * as appActions from "../../core/app.store";
import * as config from '../../common/config'

import headCellsListHerdsman from './head-cell-list-herdsman';
import DataTableSarang from '../../components/datatable-sarang';

import viVN from "../../language/vi-VN.json";
import { NotificationMessageType, getUserInfo, sendReactGaEvent } from "../../utils/configuration";
import ShowNotification from "../../components/react-notifications/react-notifications";
import { permission } from "../../common/constant";
import { useMediaQuery } from 'react-responsive';
import * as customerManagementAction from "../../redux/store-sarang/customer/customer-management.store";

import FormSearchWrapperSarang from '../../components/form-search-wrapper-sarang/form-search-wrapper-sarang';
import DataTablePagination from '../../components/datatable-sarang/datatable-pagination';
import { BodyDesktop, BodyMobile } from './components/body-list-herdsman';

import { useLookupZion } from '../../hooks/useLookupZion';
import { useLookupZionArea } from '../../hooks/useLookupZionArea';
import { useLookupDepartment } from '../../hooks/useLookupDepartment';
import { useLookupGroup } from '../../hooks/useLookupGroup';
import { useLookupDistrict } from '../../hooks/useLookupDistrict';
import { useLookupPosition } from '../../hooks/useLookupPosition';
import { useLookupWMTeam } from '../../hooks/useLookupWMTeam';
import { useLookupBranch } from '../../hooks/useLookupBranch';
import { useHerdsmanData } from './hooks/useHerdsmanData';
import { useHerdsmanActions } from './hooks/useHerdsmanActions';
import HerdsmanSearchForm from './components/HerdsmanSearchForm';
import HerdsmanModals from './components/HerdsmanModals';

const configLocal = {
    defaultPageSize: config.Configs.DefaultPageSize,
    sortExpression: "modifiedDate desc",
    orderBy: "modifiedDate",
    order: "desc",
}

export default function HerdsmanList() {
    const isDesktopOrLaptop = useMediaQuery({ query: "(min-width: 1024px)" });
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1023px)" });

    const { register, handleSubmit, setValue, control } = useForm({
        mode: "all",
        reValidateMode: "onBlur",
    });
    const dispatch = useDispatch();
    const showLoading = React.useCallback((data) => dispatch(appActions.ShowLoading(data)), [dispatch]);

    const userInfo = getUserInfo();
    const [customer, setCustomer] = useState([]);
    const [openSearch, setOpenSearch] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const { branch, getLookupBranch } = useLookupBranch();
    const { district, getLookupDistrict } = useLookupDistrict();
    const { departmentAll, departmentOptions, getLookupDepartment } = useLookupDepartment();
    const { zion, getLookupZion } = useLookupZion();
    const { zionArea, getLookupZionArea } = useLookupZionArea();
    const { group, getLookupGroup } = useLookupGroup();
    const { position, setPosition, originPosition, getLookupPosition } = useLookupPosition();
    const { wMTeam, getLookupWMTeam } = useLookupWMTeam();

    const {
        data, totalItemCount, page, setPage, rowsPerPage, setRowsPerPage, order, setOrder, orderBy, setOrderBy, searchData, setSearchData, getListHerdsmanManagement, getUserDetail
    } = useHerdsmanData(showLoading, configLocal, setValue);

    const {
        buttonOpenAddEditRef, buttonOpenConfirmRef, isOpenAddEditDialog, isOpenDeleteDialog, isOpenActiveDialog, isOpenDeactiveDialog, isOpenUpgradeDialog, isOpenDowngradeDialog,
        isOpenCreateAccountDialog, isOpenAlertUserName, setOpenAlertUserName, isOpenSendMessage, isOpenBulkCreateConfirm, setOpenBulkCreateConfirm, isOpenAssignPermission,
        isOpenBulkCreateResult, setOpenBulkCreateResult, bulkCreateResult, selectedItem, user,
        setOpenSendMessage, setOpenDeactiveDialog, setOpenActiveDialog, setOpenCreateAccountDialog, setOpenDeleteDialog,
        openAddDialog, openEditDialog, closeAddEditDialog, openSendMessageDialog, closeSendMessageDialog, openConfirmDialog, closeConfirmDialog,
        openAssignPermissionDialog, closeAssignPermissionDialog,
        handleSubmitAddEditHerdsman, handleSubmitSendMessage, handleConfirm, updatePermission, handleBulkCreateUsers, onConfirmBulkCreate
    } = useHerdsmanActions(showLoading, getListHerdsmanManagement, page, rowsPerPage, orderBy, order, searchData, originPosition, setPosition);

    const fetchData = React.useCallback(async () => {
        showLoading(true);
        try {
            await Promise.allSettled([
                getLookupZion(), getLookupZionArea(), getLookupDepartment(), getLookupGroup(), getLookupDistrict(), getLookupPosition(), getLookupWMTeam(), getLookupBranch()
            ]);
        } catch (err) {
            if (err && err.errorType) ShowNotification(viVN.Errors[err.errorType], NotificationMessageType.Error);
        } finally {
            showLoading(false);
        }
    }, [showLoading, getLookupZion, getLookupZionArea, getLookupDepartment, getLookupGroup, getLookupDistrict, getLookupPosition, getLookupWMTeam, getLookupBranch]);

    useEffect(() => {
        getUserDetail();
        fetchData();
    }, [getUserDetail, fetchData]);

    const getHerdsmanCustomer = async (herdsmanId) => {
        sendReactGaEvent('Herdsman', 'getHerdsmanCustomer');
        try {
            const res = await customerManagementAction.GetMyCustomer(0, 0, herdsmanId);
            if (res && res.content) setCustomer(res.content);
        } catch (err) {
            if (err && err.errorType) ShowNotification(viVN.Errors[err.errorType], NotificationMessageType.Error);
        }
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        getListHerdsmanManagement(page + 1, rowsPerPage, `${property} ${isAsc ? 'desc' : 'asc'}`, searchData);
    };

    const handleChangePage = (newPage) => {
        setPage(newPage - 1);
        getListHerdsmanManagement(newPage, rowsPerPage, `${orderBy} ${order}`, searchData);
    };

    const handleChangeRowsPerPage = (event) => {
        const newRows = parseInt(event.target.value, 10);
        setRowsPerPage(newRows);
        setPage(0);
        getListHerdsmanManagement(1, newRows, `${orderBy} ${order}`, searchData);
    };

    const handleCopy = async () => {
        if (user) {
            navigator.clipboard.writeText(`${user.user}/${user.pwd}`);
            ShowNotification("Đã copy", NotificationMessageType.Success);
        } else {
            ShowNotification("không tồn tại", NotificationMessageType.Warning);
        }
    }

    const closeAlertDialog = () => setOpenAlertUserName(false);

    const onSubmit = (data) => {
        setSearchData(data);
        setPage(0);
        getListHerdsmanManagement(1, rowsPerPage, `${orderBy} ${order}`, data);
    }

    const canManageUser = userInfo && userInfo.userRoles && (
        userInfo.userRoles.includes(permission.Admin) || userInfo.userRoles.includes(permission.ChiHoiTruong) ||
        userInfo.userRoles.includes(permission.HoiTruong) || userInfo.userRoles.includes(permission.Diavuctruong) || userInfo.userRoles.includes(permission.Dvt_hn)
    );

    const handleCusClose = () => setAnchorEl(null);

    return (
        <>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <FormSearchWrapperSarang
                        isTabletOrMobile={isTabletOrMobile} openSearch={openSearch} setOpenSearch={setOpenSearch} openAddDialog={() => openAddDialog(userInfo)}
                    >
                        <HerdsmanSearchForm
                            register={register} control={control} handleSubmit={handleSubmit} onSubmit={onSubmit}
                            branch={branch} department={departmentOptions} openAddDialog={() => openAddDialog(userInfo)}
                        />
                    </FormSearchWrapperSarang>

                    {isDesktopOrLaptop && (
                        <DataTableSarang
                            rowsPerPage={rowsPerPage} handleChangeRowsPerPage={handleChangeRowsPerPage}
                            headCells={headCellsListHerdsman} handleRequestSort={handleRequestSort} order={order} orderBy={orderBy}
                            totalItemCount={totalItemCount} setRowsPerPage={setRowsPerPage} pageIndex={page} handleChangePage={handleChangePage}
                            hideButtons={true} customButtons={canManageUser && (
                                <button className="btn btn-outline-primary" type="button" onClick={() => handleBulkCreateUsers()}>
                                    <span>Tạo tài khoản đăng nhập</span>
                                </button>
                            )}
                        >
                            <BodyDesktop
                                data={data} isShowActionButton={true} userInfo={userInfo}
                                setOpenSendMessage={setOpenSendMessage} openSendMessageDialog={openSendMessageDialog}
                                setOpenDeactiveDialog={setOpenDeactiveDialog} openConfirmDialog={openConfirmDialog}
                                setOpenActiveDialog={setOpenActiveDialog} setOpenCreateAccountDialog={setOpenCreateAccountDialog}
                                updatePermission={updatePermission} openEditDialog={(item) => openEditDialog(item, userInfo)}
                                setOpenDeleteDialog={setOpenDeleteDialog} handleBulkCreateUsers={handleBulkCreateUsers}
                                openAssignPermissionDialog={openAssignPermissionDialog}
                            />
                        </DataTableSarang>
                    )}

                    {isTabletOrMobile && (
                        <div className="accrodion-regular">
                            <div id="accordion">
                                <div className="card">
                                    <div className="d-flex align-items-center">
                                        <div className="list-group-item list-group-item-action flex-column align-items-start collapsed" style={{ border: "none" }} data-toggle="collapse" aria-expanded="false">
                                            <div className="d-flex w-100">
                                                <label className='d-flex align-items-end justify-content-end' style={{ gap: "10px" }}>
                                                    Xem
                                                    <select className="custom-select custom-select-sm form-control form-control-sm" style={{ width: "50px" }} value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                                                        {config.Configs.DefaultPageSizeOption.map((pageSize, index) => (
                                                            <option key={index} value={pageSize}>{pageSize}</option>
                                                        ))}
                                                    </select>
                                                    mục
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <BodyMobile
                                        data={data} isShowActionButton={true} userInfo={userInfo}
                                        setOpenSendMessage={setOpenSendMessage} openSendMessageDialog={openSendMessageDialog}
                                        setOpenDeactiveDialog={setOpenDeactiveDialog} openConfirmDialog={openConfirmDialog}
                                        setOpenActiveDialog={setOpenActiveDialog} setOpenCreateAccountDialog={setOpenCreateAccountDialog}
                                        updatePermission={updatePermission} openEditDialog={(item) => openEditDialog(item, userInfo)}
                                        setOpenDeleteDialog={setOpenDeleteDialog} handleBulkCreateUsers={handleBulkCreateUsers}
                                        openAssignPermissionDialog={openAssignPermissionDialog}
                                    />
                                </div>
                                {totalItemCount > 0 && (
                                    <DataTablePagination totalItemCount={totalItemCount} rowsPerPage={rowsPerPage} pageIndex={page + 1} handleChangePage={handleChangePage} />
                                )}
                            </div>
                        </div>
                    )}
                </div>

                <button ref={buttonOpenAddEditRef} type="button" className="d-none" data-toggle="modal" data-target="#modalSubmitForm">Launch modal add edit</button>
                <button ref={buttonOpenConfirmRef} type="button" className="d-none" data-toggle="modal" data-target="#modalConfirm">Launch modal confirm</button>

                <HerdsmanModals
                    anchorEl={anchorEl} handleCusClose={handleCusClose} customer={customer} open={open}
                    isOpenSendMessage={isOpenSendMessage} selectedItem={selectedItem} isOpenAddEditDialog={isOpenAddEditDialog}
                    closeAddEditDialog={closeAddEditDialog} closeSendMessageDialog={closeSendMessageDialog}
                    group={group} herdsman={[]} zion={zion} zionArea={zionArea} district={district}
                    position={originPosition} wMTeam={wMTeam} branch={branch} department={departmentOptions}
                    handleSubmitAddEditHerdsman={handleSubmitAddEditHerdsman}
                    handleSubmitSendMessage={handleSubmitSendMessage} isOpenDeleteDialog={isOpenDeleteDialog} isOpenActiveDialog={isOpenActiveDialog}
                    isOpenUpgradeDialog={isOpenUpgradeDialog} isOpenDowngradeDialog={isOpenDowngradeDialog} isOpenDeactiveDialog={isOpenDeactiveDialog}
                    isOpenCreateAccountDialog={isOpenCreateAccountDialog} closeConfirmDialog={closeConfirmDialog} handleConfirm={handleConfirm}
                    isOpenAlertUserName={isOpenAlertUserName} user={user} closeAlertDialog={closeAlertDialog} handleCopy={handleCopy}
                    isOpenBulkCreateResult={isOpenBulkCreateResult} setOpenBulkCreateResult={setOpenBulkCreateResult} bulkCreateResult={bulkCreateResult}
                    isOpenBulkCreateConfirm={isOpenBulkCreateConfirm} setOpenBulkCreateConfirm={setOpenBulkCreateConfirm} onConfirmBulkCreate={onConfirmBulkCreate}
                    isOpenAssignPermission={isOpenAssignPermission} closeAssignPermissionDialog={closeAssignPermissionDialog} getListHerdsmanManagement={getListHerdsmanManagement}
                    page={page} rowsPerPage={rowsPerPage} orderBy={orderBy} order={order} searchData={searchData} showLoading={showLoading}
                />
            </div>
        </>
    );
}